// Butoane blocate pentru cine nu are dreptul: `<button {...lock(has("users.update"))}>`. Un buton blocat rămâne vizibil
// (gri, cu explicație la trecerea mouse-ului), ca persoana să știe că funcția există, dar să nu o poată apăsa.
export const NO_RIGHT = "Nu ai dreptul pentru această acțiune";
export const lock = (allowed, why) => (allowed ? {} : { disabled: true, title: why || NO_RIGHT, "aria-disabled": true });
